import { Flex, Icon, Text } from '@chakra-ui/react';
import IconCheck from 'assets/icons/icon-check.svg?react';
import type {
  GroupBase,
  MultiValue,
  Options,
  ValueContainerProps
} from 'chakra-react-select';

import {
  chakraComponents
} from 'chakra-react-select';

interface ItemOption {
  value: unknown,
  label: string
}

const ValueContainer = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>( { children, ...props }: ValueContainerProps<Option, IsMulti, Group>) => {
  const { selectProps: { placeholder  } } = props;
  const value: MultiValue<ItemOption> = props.selectProps.value as MultiValue<ItemOption>;
  const selectedValues = value ? value.map(({ value }) => value) : [];

  const options: Options<ItemOption> = props.selectProps.options as Options<ItemOption>;
  const allOptions = options.map(({ value }: ItemOption) => value);

  const allSelected = allOptions.every((el) => selectedValues.includes(el));
  const text = (!value || value.length === 0 || allSelected) ? placeholder : value.map(({ label }) => label).join(', ')
  
  return (
    <chakraComponents.ValueContainer {...props}>
      <>
        <Flex 
          pos="absolute" 
          left="9px" 
          gap="2px" 
          className="custom-rendered-value"
        >
          <Icon as={IconCheck} boxSize="20px" flexShrink={0} />
          <Text noOfLines={1}>{text}</Text>
        </Flex>
        {children}
      </>
    </chakraComponents.ValueContainer>
  );
};

export default ValueContainer;